// WebSocket helper — builds ws(s):// URL from REACT_APP_BACKEND_URL and manages reconnect.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';

export function wsUrl(path) {
  const base = BACKEND_URL.replace(/^http/, 'ws');
  return `${base}/api/ws${path}`;
}

export function createSocket(path, { onMessage, onOpen } = {}) {
  let ws;
  let closed = false;
  let retry;

  const connect = () => {
    try {
      ws = new WebSocket(wsUrl(path));
      ws.onopen = () => onOpen && onOpen(ws);
      ws.onmessage = (e) => {
        try { onMessage && onMessage(JSON.parse(e.data)); } catch {}
      };
      ws.onclose = () => {
        if (!closed) retry = setTimeout(connect, 2500);
      };
      ws.onerror = () => { try { ws.close(); } catch {} };
    } catch {}
  };
  connect();

  return {
    send: (data) => { try { ws && ws.readyState === 1 && ws.send(JSON.stringify(data)); } catch {} },
    close: () => { closed = true; clearTimeout(retry); try { ws && ws.close(); } catch {} },
  };
}
